import React from "react";

// Import Css
import './footerComponent.css'

//Import AwesomeIcon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

// Import Assets
import LogoWebMediaFooter from '../../assets/homeAssets/logoWebMedia.svg'


export function FooterComponent() {
    return(


        <div className="conteiner-all-footer">

            {/* <div className="banner-blue-component"></div> */}

            <div className="box-footer-content">

                <div className="box-block-A-info">


                    <div className="box-title-contact">

                        <h2 className="title-contact">CONTÁCTANOS</h2>
                        <a className="link-to-contact link-to-email" href="mailto:clientes@webmedia.com">clientes@webmedia.com</a>
                        <a className="link-to-contact link-to-telf" href="tel:+593987654321">Ec. 593 + 099 9909 735</a>

                    </div>

                    {/*  ____________________ */}

                    <div className="line-divisor-webmedia"></div>

                    {/* ____________________ */}

                    <div className="box-siguenos-icons">

                        <p className="text-siguenos">Síguenos</p>
                        
                        {/* BOX ICONOS REDES */}
                        <div className="box-icon-redes-contact">

                            <a className="icon-social-media icon-fb" href="#" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faFacebookF}/>
                            </a>

                            <a className="icon-social-media icon-tk" href="#" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faTiktok}/>
                            </a>

                            <a className="icon-social-media icon-Ins" href="#" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faInstagram}/>
                            </a>

                            <a className="icon-social-media icon-Wts" href="https://wa.me/593992818717" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faWhatsapp}/>        
                            </a>

                        </div>

                    </div>

                </div>
                {/* Fin BLoque A */}


                <div className="box-block-B-logo"> 

                    <img className="logo-webmedia-footer" src={LogoWebMediaFooter} alt="Web Media"/>
                    <p className="text-develop-footer">Desarrollado por Webmedia</p>
                    <p className="text-copyright">Copyright 2026 - 2027</p>

                </div>
                 {/* Fin BLoque B */}
                
            </div>


        </div>


    );
}